import React from "react";

import * as S from "../styled";
import { ModalContext } from "../SuccessMessageModal";

function SuccessIcon(props) {
  return (
    <ModalContext.Consumer>
      {context => <S.SuccessIcon {...props} layout={context.layout} />}
    </ModalContext.Consumer>
  );
}

export default SuccessIcon;
